module.exports = __webpack_public_path__ + "img/zip.764c239e.svg";